









































import { Component, Prop, Vue } from "@/shared/vuepack";
import { HsabAccountNametag, TransactionFilter } from "@/shared/types";
import { formatCurrency } from "@/shared/currency.js";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import Tab from "@/shared/components/ui/Tab.vue";
import TabGroup from "@/shared/components/ui/TabGroup.vue";
import NotionalBalanceLineChart from "@/shared/components/charts/NotionalLineChart.vue";
import AddMfa from "@/employee/components/onboarding/AddMfa.vue";
import CashAccountTabs from "@/shared/components/cash/CashAccountTabs.vue";
import { useUserStore } from "@/shared/store/user";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import HsabNotionalAccountTransactions from "@/employee/components/landing-pages/hsabank/notionalAccount/HsabNotionalAccountTransactions.vue";
import moment from "moment";
import { formatMMMDateString, formatMMMDateStringUtc } from "@/shared/dateString";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    CashAccountTabs,
    AddMfa,
    NotionalBalanceLineChart,
    HsabNotionalAccountTransactions,
    TabGroup, Tab, SsoDeepLink
  }
})
export default class HsabNotionalAccount extends Vue {
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();
  hsabAccountsStore = useHsabAccountsStore();
  formatMMMDateString = formatMMMDateString;
  formatMMMDateStringUtc = formatMMMDateStringUtc;
  @Prop()
  page: number;
  @Prop()
  routeToNotionalAccountBalance: (pageNumber: number, filter: TransactionFilter) => Location | any;
  @Prop()
  transactionFilter: TransactionFilter;
  formatCurrency = formatCurrency;

  get accountId () {
    return parseInt(this.$route.params.accountId);
  }

  get notionalAccount (): HsabAccountNametag | any {
    const accounts = this.hsabAccountsStore.notionalAccounts.find(t => t.accountId === this.accountId);
    if (accounts) {
      return accounts;
    }
    return {};
  }

  get cashAccountBalanceLoaded (): boolean {
    return this.hsabAccountsStore.allHsabAccountsLoaded;
  }
  get isBalanceDateInUtc () {
    return this.featureFlagStore.flags.bend20582UseGetPlansAndBalances;
  }

  mounted () {
    this.hsabAccountsStore.getHsabAccounts();
  }
}
